import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseURL } from "@/utility/api";
import {
  Rocket,
  Briefcase,
  Calendar,
  Clock,
  BookOpen,
  FileText,
  Mail,
  User,
  Users,
  Award,
  Target,
  TrendingUp,
  FileCheck,
  Presentation,
  CalendarDays,
  HelpCircle,
  ChevronDown,
  ChevronUp,
  Phone,
  Bookmark,
  PenLine,
} from "lucide-react";

import SDEHero from "@/components/SDE/SDEHero";
import SDECurriculum from "@/components/SDE/SDECurriculum";
import ProblemSolution from "@/components/SDE/ProblemSolution";
import WhatYoullLearn from "@/components/SDE/WhatYoullLearn";
import WhoIsThisFor from "@/components/SDE/WhoIsThisFor";
import SDEInstructor from "@/components/SDE/SDEInstructor";

// Main Page Component
const SDECohort = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [details, setDetails] = useState({
    price: 699,
    canApply: true,
    seats_left: 25,
  });

  useEffect(() => {
    setIsVisible(true);

    async function fetchData() {
      const response = await axios.post(`${baseURL}/cohort/get-details`, {
        id: 105,
      });

      // console.log("Fetched SDE Cohort Details:", response.data);
      setDetails(response.data);
    }
    fetchData();
  }, []);

  // console.log("SDE Cohort Details:", details);

  return (
    <div className="min-h-screen bg-black text-white font-inter px-0 md:px-0">
      {/* Hero Section */}
      <SDEHero details={details} />
      <ProblemSolution />
      <WhatYoullLearn />
      <WhoIsThisFor />
      <SDEInstructor />
      <SDECurriculum />
    </div>
  );
};

export default SDECohort;
//
